module.exports = __webpack_public_path__ + "images/logo-ftc.jpg?v=cddb3b4b2721754b0a6942ed98a9a57d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logo-ftc.jpg
// module id = 620
// module chunks = 0